module.exports = __webpack_public_path__ + "static/media/MJBDKY.crop.bd085bdf.jpg";